import React from "react";

const Input = React.forwardRef(({ optional, ...props }, ref) => {
  const hasError = !!props.errormessage;
  return (
    <div>
      <label
        htmlFor={props.id ?? props.name}
        className="block text-sm/6 font-medium text-ink-700"
      >
        {props.label}
        {optional && (
          <span className="ml-1 font-normal text-ink-400">(optional)</span>
        )}
      </label>
      <div className="mt-2">
        <input
          id={props.id ?? props.name}
          className={`block w-full rounded-card border bg-white px-3.5 py-2.5 text-base text-ink-900 placeholder:text-ink-400 transition-colors duration-150 ease-editorial focus:outline-none focus:ring-2 ${
            hasError
              ? "border-l-4 border-l-signal-red-500 border-y border-r border-ink-200 focus:ring-signal-red-500/20"
              : "border-ink-200 focus:border-accent-500 focus:ring-accent-500/20"
          } sm:text-sm sm:leading-6 appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-moz-appearance:textfield]`}
          ref={ref}
          disabled={props.disabled}
          {...props}
        />
        {hasError ? (
          <div className="mt-2 text-sm text-signal-red-700">
            <p>{props.errormessage}</p>
          </div>
        ) : null}
      </div>
    </div>
  );
});

Input.displayName = "Input";

export default Input;
